import React from 'react';

const BasicNonEditField = ({ input, label }) => (
  <div className='control'>
    <label>{label} </label>
    <label className="label-input"> {input.value}</label>
  </div>
);

export default BasicNonEditField;